import About from './about'
import Unauthorized from './unauthorized'
import Dashboard from './dashboard'
import FourOhFour from './404'
import Embed from './embed'
import { logger } from 'helpers'

var views = []
try {
  // eslint-disable-next-line
  views = require('projects/' + process.env.REACT_APP_PROJECT + '/views/core/index.js')
} catch (e) {
  logger.debug('No project-specific core views')
}

module.exports = {
  About,
  Dashboard,
  FourOhFour,
  Unauthorized,
  Embed,
  ...views
}



// WEBPACK FOOTER //
// ./src/views/core/index.js